let graphicLayer, contourLine;
export default {
  // inject:['marsMap','marsMeasure'],
  props: ["heightInterval"],
  data() {
    return {
      contourLine_show: true,
      heightIntervalNumber: 5,
      isFold: false,
    };
  },
  methods: {
    adjustHeightInterval() {
      // alert("触发！");
      //this.$emit('changeHeightInterval', this.heightIntervalNumber);
      contourLine.spacing = this.heightIntervalNumber;
      console.log(this.heightIntervalNumber);
    },
    contourLineBox_close() {
      // this.transparency_show = false;
      this.removeAll();
      this.$emit("contourLineBox_close");
    },
    addRectangle() {
      let that = this;
      graphicLayer.startDraw({
        type: "rectangle",
        style: {
          color: "#007be6",
          opacity: 0.8,
          outline: false,
        },
        success: function(graphic) {
          //绘制成功后回调
          let positions = graphic.getOutlinePositions(false);
          graphicLayer.clear();

          console.log(
            JSON.stringify(mars3d.PointTrans.cartesians2lonlats(positions))
          ); //打印下边界

          contourLine.addArea(positions);
        },
      });
    },
    addPolygon() {
      let that = this;
      graphicLayer.startDraw({
        type: "polygon",
        style: {
          color: "#007be6",
          opacity: 0.5,
          outline: false,
        },
        success: function(graphic) {
          //绘制成功后回调
          let positions = graphic.positionsShow;
          graphicLayer.clear();

          console.log(
            JSON.stringify(mars3d.PointTrans.cartesians2lonlats(positions))
          ); //打印下边界

          contourLine.addArea(positions);
        },
      });
    },
    removeAll() {
      contourLine.clear(); //清除挖地区域
      graphicLayer.clear();
    },
  },
  mounted() {
    console.log(
      mars3d.PointTrans.proj4Trans(
        [113.670872, 22.879918, 1713.8],
        mars3d.CRS.EPSG4326,
        "+proj=tmerc +lat_0=0 +lon_0=113.75 +k=1 +x_0=500000 +y_0=0 +ellps=GRS80 +units=m +no_defs"
      )
    );
    console.log(
      mars3d.PointTrans.proj4Trans(
        [491880.43672473636, 2531241.4969900534, 1713.8],
        "+proj=tmerc +lat_0=0 +lon_0=113.75 +k=1 +x_0=500000 +y_0=0 +ellps=GRS80 +units=m +no_defs",
        mars3d.CRS.EPSG4326
      )
    );

    if (this.heightInterval) {
      this.heightIntervalNumber = this.heightInterval;
    }

    if (!graphicLayer) {
      graphicLayer = new mars3d.layer.GraphicLayer();
      this.$GLOBAL.map.addLayer(graphicLayer);
    }

    contourLine = new mars3d.thing.ContourLine({
      spacing: this.heightIntervalNumber,
      width: 2,
      color: Cesium.Color.RED,
      minHeight: -414.0,
      maxHeight: 8777.0,
      //地表渲染的配色方案
      // colorScheme: {
      //   elevation: {
      //     step: [0.0, 0.045, 0.1, 0.15, 0.37, 0.54, 1.0],
      //     color: ["#000000", "#2747E0", "#D33B7D", "#D33038", "#FF9742", "#FF9742", "#ffd700"],
      //   },
      //   slope: {
      //     step: [0.0, 0.29, 0.5, Math.sqrt(2) / 2, 0.87, 0.91, 1.0],
      //     color: ["#000000", "#2747E0", "#D33B7D", "#D33038", "#FF9742", "#FF9742", "#ffd700"],
      //   },
      //   aspect: {
      //     step: [0.0, 0.2, 0.4, 0.6, 0.8, 0.9, 1.0],
      //     color: ["#000000", "#2747E0", "#D33B7D", "#D33038", "#FF9742", "#FF9742", "#ffd700"],
      //   },
      // },
    });
    this.$GLOBAL.map.addThing(contourLine);
  },
  destroyed() {
    //alert(1);
    //this.$GLOBAL.map.removeLayer(tilesetLayer,true);
    graphicLayer.clear();
    this.$GLOBAL.map.removeLayer(graphicLayer, true);
    this.$GLOBAL.map.removeThing(contourLine, true);
    graphicLayer = null;
    contourLine = null;
  },
  watch: {},
};
